import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useStores } from '@gtintel/platform-stores';
import { TagRequestMode } from '@gtintel/platform-types';
const TagContainer = props => {
  const {
    children
  } = props;
  const {
    tagGroupStore
  } = useStores();
  useEffect(() => {
    tagGroupStore.fetchTagGroups(TagRequestMode.NONE_RELATION);
    tagGroupStore.fetchTagTypeOptionsRecursively();
  }, []);
  return <>{children}</>;
};
export default observer(TagContainer);